import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Panel } from "@/components/core/AppLayout";
import { BiField } from "./CaseFields";

const FIELDS = [["hero_title", "Titolo hero (H1)", false], ["hero_sub", "Sottotitolo hero", true], ["about_p1", "Chi siamo – paragrafo 1", true],
  ["about_p2", "Chi siamo – paragrafo 2", true], ["about_p3", "Chi siamo – paragrafo 3", true], ["quote", "Frase in evidenza", true]];

export const SiteTexts = () => {
  const [f, setF] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/sito/testi").then((r) => setF(r.data)); }, []);
  const save = async () => {
    setSaving(true);
    try { const r = await api.put("/sito/testi", f); setF(r.data); toast.success("Testi del sito salvati"); }
    catch (e) { toast.error(errMsg(e)); }
    finally { setSaving(false); }
  };
  if (!f) return null;
  return (
    <Panel className="p-5 sm:p-8 grid gap-5" data-testid="site-texts">
      <p className="text-sm text-slate-600">Testi principali della home di corefvg.com, in italiano e inglese. Se lasci un campo vuoto viene usato il testo originale.</p>
      {FIELDS.map(([k, l, area]) => <BiField key={k} label={l} value={f[k]} onChange={(v) => setF({ ...f, [k]: v })} area={area} testid={`site-text-${k}`} />)}
      <div className="flex flex-wrap gap-2 justify-end">
        <a href="/" target="_blank" rel="noreferrer" className="inline-flex h-10 items-center rounded-full border border-[#0A1128]/20 px-4 text-sm font-bold" data-testid="site-texts-preview">Apri il sito</a>
        <Button onClick={save} disabled={saving} className="rounded-full bg-[#E8173A] hover:bg-[#C8102E] font-bold" data-testid="site-texts-save">{saving ? "Salvataggio…" : "Salva testi"}</Button>
      </div>
    </Panel>
  );
};
